/**
 * @Time    : 2024/1/12 15:42
 * @Author  : tlovet
 * @Software: WebStorm
 */

/**
 * 加水印
 @export
 container = document.body,
 width = '150px',
 height = '60px',
 textAlign = 'center',
 textBaseline = 'middle',
 font = "14px Microsoft Yahei",
 fillStyle = 'rgba(0, 0, 0, 0.1)',
 content = '保密水印',
 rotate = '-10',
 zIndex = 10000,
 innerDom = '.innerdom', 水印div的class，默认是.innerdom
 }={}]
 @returns
 * @param options
 */

type WatermarkOptions = {
  container?: any;
  width?: string;
  height?: string;
  textAlign?: 'center';
  textBaseline?: 'middle';
  font?: string;
  fillStyle?: string;
  content: string | any;
  rotate?: number;
  zIndex?: number;
  innerDom?: string;
};
export const watermark = (options: WatermarkOptions) => {
  const {
    container = document.body,
    width = '350px',
    height = '250px',
    textAlign = 'center',
    textBaseline = 'middle',
    font = '14px Microsoft YaHei',
    fillStyle = 'rgba(100, 100, 100, 0.09)',
    content = '文字示例',
    rotate = -15,
    zIndex = 10000,
    innerDom = '.innerdom',
  } = options || {};
  const canvas = document.createElement('canvas');
  canvas.setAttribute('width', width);
  canvas.setAttribute('height', height);
  const ctx = canvas.getContext('2d');
  if (ctx === null) {
    // 报错
    console.error('this browser is not support canvas.');
    return;
  }
  ctx.textAlign = textAlign;
  ctx.textBaseline = textBaseline;
  ctx.font = font;
  // 透明度
  ctx.fillStyle = fillStyle;
  // 旋转角度
  ctx.rotate((Math.PI / 180) * rotate);
  // 垂直显示
  // ctx.fillText(content, parseFloat(width) / 2, parseFloat(height) / 2);
  // 错落显示
  if (Array.isArray(content)) {
    content.forEach((item, index) => {
      ctx.fillText(item, 50, 50 + index * 20);
      ctx.fillText(item, 200, 200 + index * 20);
    });
  } else {
    ctx.fillText(content, 50, 50);
    ctx.fillText(content, 200, 200);
  }
  const base64Url = canvas.toDataURL();
  let innerdom = document.querySelector(innerDom);
  const watermarkDiv = innerdom || document.createElement('div');
  const styleStr = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zIndex};
    background-repeat: repeat;
    pointer-events: none;
    background: url('${base64Url}') repeat rgba(0,0,0,0)`;
  watermarkDiv.setAttribute('style', styleStr);
  watermarkDiv.classList.add('innerdom');

  let containerDom = container;
  if (!container) {
    containerDom = document.querySelector('#root');
  }
  if (!innerdom) {
    // 防止因指定的div未渲染而引起的报错
    try {
      containerDom.style.position = 'relative';
      containerDom.insertBefore(watermarkDiv, containerDom.firstChild);
    } catch (error) {
      return;
    }
  }
  // @ts-ignore
  const MutationObserver = window?.MutationObserver || window?.WebKitMutationObserver;
  if (MutationObserver) {
    let mo: any = new MutationObserver(() => {
      innerdom = document.querySelector(innerDom);
      // 水印删除或增加display:none样式时，重新生成水印；防止水印被删除
      if ((innerdom && innerdom.getAttribute('style') !== styleStr) || !innerdom) {
        mo.disconnect();
        mo = null;
        watermark(options);
      }
    });
    mo.observe(containerDom, {
      attributes: true,
      subtree: true,
      childList: true,
    });
  }
};
